import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="font-heading text-lg font-bold mb-4">
              <Link to="/" className="hover:text-primary-400 transition-colors cursor-pointer">韩漫漫画网</Link>
            </h4>
            <p className="text-sm text-foreground-300 leading-relaxed">
              最新高清免费韩国漫画大全，热门韩漫在线观看。画面精美，更新及时，随时随地满足您的观漫需求。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold mb-4">快速导航</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">首页</Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">全部分类</Link>
              </li>
              <li>
                <Link to="/category/romance" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">恋爱漫画</Link>
              </li>
              <li>
                <Link to="/category/fantasy" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">奇幻漫画</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold mb-4">热门分类</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/category/action" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">动作漫画</Link>
              </li>
              <li>
                <Link to="/category/mystery" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">悬疑漫画</Link>
              </li>
              <li>
                <Link to="/category/comedy" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">搞笑漫画</Link>
              </li>
              <li>
                <Link to="/category/bl" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">耽美漫画</Link>
              </li>
              <li>
                <Link to="/category/drama" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">剧情漫画</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold mb-4">联系我们</h4>
            <ul className="space-y-2 text-sm text-foreground-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>contact@hanmancomic.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-2-line"></i>
                <span>在线客服：工作日 9:00-18:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 韩漫漫画网 hanmancomic.com 版权所有
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-400">
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">服务条款</a>
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}